import cx from 'classnames';

import { StyledPage } from './StyledComponents';
import type { ReactElement } from 'react';

type Props = {
  className?: string;
  noPadding?: boolean;
  children?: ReactElement;
};

const Page = (props: Props) => {
  const { noPadding = false, className = '' } = props;
  return (
    <StyledPage noPadding={noPadding} className={cx(className)}>
      {props.children}
    </StyledPage>
  );
};

export { Page };
export default Page;
